import { defineMessages } from "react-intl";

const messages = defineMessages({
  createError: {
    id: "resources.externalResources.create.error",
    defaultMessage: "Unable to create connection",
    description: "Storage connection create error message",
  },
  createSuccess: {
    id: "resources.externalResources.create.success",
    defaultMessage: "Connection created",
    description: "Storage connection create success message",
  },
  deleteError: {
    id: "resources.externalResources.delete.error",
    defaultMessage: "Unable to delete connection",
    description: "Storage connection delete error message",
  },
  deleteSuccess: {
    id: "resources.externalResources.delete.success",
    defaultMessage: "Connection deleted",
    description: "Storage connection delete success message",
  },
  syncCompleted: {
    id: "resources.externalResources.sync.completed",
    defaultMessage: "{provider} sync completed successfully",
    description: "Storage connection sync completed successfully message",
  },
  syncCompletedWithErrors: {
    id: "resources.externalResources.sync.completedWithErrors",
    defaultMessage: "{provider} sync partially completed",
    description: "Storage connection sync completed with errors message",
  },
  syncError: {
    id: "resources.externalResources.sync.error",
    defaultMessage: "Unable to start sync",
    description: "Storage connection sync error message",
  },
  syncFailed: {
    id: "resources.externalResources.sync.failed",
    defaultMessage: "{provider} sync failed",
    description: "Storage connection sync failed message",
  },
  syncPollError: {
    id: "resources.externalResources.sync.pollError",
    defaultMessage: "Unable to check sync progress",
    description: "Storage connection sync polling error message",
  },
  syncStarted: {
    id: "resources.externalResources.sync.started",
    defaultMessage: "Connection sync started",
    description: "Storage connection sync started message",
  },
  updateError: {
    id: "resources.externalResources.update.error",
    defaultMessage: "Unable to update connection",
    description: "Storage connection update error message",
  },
});

export default messages;
